/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
/**
 * Copyright 2025, IntraLinks, Inc. All rights reserved.
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ToastComponent from '../Toast/ToastComponent';
import { RootState } from '../../../store';
import { showToast } from '../../AppSlice/AppSlice';
import styles from './GlobalReduxToast.scss';

export default function GlobalReduxToast() {
  const dispatch = useDispatch();
  const toastDetails = useSelector((s: RootState) => s.appState.toastDetails);

  if (toastDetails.timeout !== 0) return null;

  return (
    <div className={styles.toastLayer}>
      <div className={styles.toastCard}>
        <ToastComponent
          {...toastDetails}
          onCloseButtonClick={() => dispatch(showToast({
            title: '', timeout: 1, kind: 'error', subtitle: ''
          }))}
        />
      </div>
    </div>
  );
}
